module.exports = __webpack_public_path__ + "img/orange.6940a649.png";